import { IMilestone, IProjectLeaderApprover } from "@/interfaces";

export interface IUpdateProjectMilestonePayload {
  id: string;
  displayName: string | undefined;
  targetDate: string | undefined;
  actualDate: string | undefined;
  areProjectSkusRequired: boolean | undefined;
  submittedDate: string | undefined;
  approvers: IMilestone["approvers"] | undefined;
  notification: IMilestone["notification"] | undefined;
  projectLeaderApprovers: IMilestone["projectLeaderApprovers"] | undefined;
  projectLeaderNotifications: IProjectLeaderApprover[] | undefined;
}

/**
 * Trims a full milestone object down to only the fields the
 * `PATCH /api/v1/projects/{projectId}/milestone` endpoint actually persists
 * (see `UpdateProjectMilestoneRequest` on the server). The rest of a
 * milestone's fields (name, abbreviation, status, childMilestones, audit
 * fields, structural/template flags, etc.) are ignored by the server and
 * are unnecessary to send over the wire.
 */
export const buildUpdateProjectMilestonePayload = (
  milestone: Partial<IMilestone> & {
    id: string;
    projectLeaderNotifications?: IProjectLeaderApprover[];
  }
): IUpdateProjectMilestonePayload => ({
  id: milestone.id,
  displayName: milestone.displayName,
  targetDate: milestone.targetDate,
  actualDate: milestone.actualDate,
  areProjectSkusRequired: milestone.areProjectSkusRequired,
  submittedDate: milestone.submittedDate,
  approvers: milestone.approvers,
  notification: milestone.notification,
  projectLeaderApprovers: milestone.projectLeaderApprovers,
  projectLeaderNotifications: milestone.projectLeaderNotifications,
});
